// Bilan du soir : reprendre en QCM ou en flashcards tout ce qu'on a travaillé dans la journée.
//
// L'idée du planning est de revoir un chapitre à J0, J1, J3… ; celle du bilan du soir est de vérifier, le
// soir même, ce qui vient d'être lu — avant que la nuit passe dessus. Il ne remplace aucune séance et ne
// touche pas au planning : il ne fait que rassembler les items de la journée et les enchaîner.
//
// « Vu ce jour » = une séance du jour COCHÉE. Une séance planifiée mais pas faite n'a rien à vérifier, et se
// tester dessus fabriquerait de faux scores dans le journal d'apprentissage.

// Les items travaillés aujourd'hui, dans l'ordre où la journée les présente, chacun une seule fois.
// Une sous-partie compte pour elle-même : son périmètre de questions et son paquet de cartes sont distincts.
window.itemsDuJour = function(taches, aujourdhui, subParts) {
    var vus = {}, sortie = [];
    (taches || []).forEach(function(t) {
        if (!t || t.isDouble || t.status !== 'done' || String(t.date) !== String(aujourdhui)) return;
        var n = String(t.baseItemId || t.itemId);
        var sp = window.sousPartieDe ? window.sousPartieDe(t, subParts, taches) : null;
        var part = (sp && sp.n > 0) ? sp.n - 1 : null;
        var pedia = !!(window.isPediaTask && window.isPediaTask(t));
        var cle = n + '#' + (part == null ? '-' : part) + (pedia ? '#p' : '');
        if (vus[cle]) return;
        vus[cle] = 1;
        sortie.push({ n: n, part: part, pedia: pedia, titre: String(t.titre || ''),
            partNom: (sp && sp.nom) || '', type: t.type });
    });
    return sortie;
};

// Avancement d'un bilan en cours, pour l'afficher sans recalculer partout la même chose.
window.avancementSoir = function(soir) {
    if (!soir || !soir.file || !soir.file.length) return null;
    var total = soir.file.length, rang = Math.min(soir.i + 1, total);
    return {
        rang: rang, total: total,
        courant: soir.file[Math.min(soir.i, total - 1)] || null,
        restants: Math.max(0, total - rang),
        faits: soir.faits || 0, justes: soir.justes || 0, sautes: (soir.sautes || []).length,
        fini: soir.i >= total,
    };
};

export const itemsDuJour = window.itemsDuJour;
export const avancementSoir = window.avancementSoir;
